// TODO: P0: posting ml.pdf freezes. Generally the text area is very slow
// TODO: P2: add number of characters
// TODO: P1: add 'type' to addArticle calls
import React, { useEffect, useMemo, useCallback, useState } from 'react';
import queryString from 'query-string';
import { Link } from 'react-router-dom';
import loadingIcon from '../Assets/loading.gif';
import { addArticleToUserPlaylist, getPresignedUrl, uploadTextToPresignedUrl } from '../audiblogsApi';
import userStore from '../Stores/User';
import store from './DiscoverNew/store.js';
import { observer } from 'mobx-react';
import { set } from 'mobx';

const EditText = observer(({ location: { search } }) => {
  const params = queryString.parse(search);
  const type = params.type || 'input_text';
  const articleUrl = params.url || '';
  const [title, setTitle] = useState(
    params.title || new Date().toString().split('GMT')[0].trim()
  );
  const [text, setText] = useState(params.text || '');
  const [backupText, setBackupText] = useState(params.backupText || '');
  const [extractionMethod, setExtractionMethod] = useState('A');
  const [isLoading, setIsLoading] = useState(false);
  const [buttonMessage, setButtonMessage] = useState('Send');
  const ARTICLE_MAX_LENGTH_HD = 500000;
  const ARTICLE_MAX_LENGTH_FREE_TIER = 500000;
  const [maxLength, setMaxLength] = useState(ARTICLE_MAX_LENGTH_FREE_TIER);
  const [preSignedUrl, setPreSignedUrl] = useState('');
  
  
  function breakStringIntoChunks(text, maxSize) {
    const paragraphs = text.split('\n'); // Split the text into paragraphs
    
    let chunk = ''; // Initialize an empty chunk
    let result = []; // Initialize an array to store the chunks
    
    for (let i = 0; i < paragraphs.length; i++) {
      const paragraph = paragraphs[i];
      const chunkSize = chunk.length + paragraph.length;
      
      if (chunkSize <= maxSize) {
        chunk += paragraph + '\n'; // Add the paragraph to the chunk with a newline
      } else {
        result.push(chunk.trim()); // Add the completed chunk to the result array
        chunk = paragraph + '\n'; // Start a new chunk with the current paragraph
      }
    }
    
    if (chunk.length > 0) {
      result.push(chunk.trim()); // Add the last chunk if it's not empty
    }
    
    return result;
  }

  useEffect(async () => {
    const preSignedUrl = await getPresignedUrl('txt');
    setPreSignedUrl(preSignedUrl);
  }, []);

  useEffect(() => {
    if (userStore.isUserPaying) {
      setMaxLength(ARTICLE_MAX_LENGTH_HD);
    }
  }, [userStore.isUserPaying]);
  return (
    <div className="center-static">
      <h1>
        {type === 'pdf'
          ? 'PDF Conversion'
          : type === 'selection_text'
          ? 'Highlighted Text'
          : 'Copy & Paste Text'}
      </h1>

      {type === 'pdf' ? (
        <div>
          <div style={{ maxWidth: '600px' }}>
            <b>NOTE</b>: Please make sure there aren't linebreaks in the middle
            of what are supposed to be single lines or paragraphs (especially
            with math equations, figures, etc).
          </div>
          <button
            className="transparent-button mobile clickable"
            style={{
              border: extractionMethod === 'A' && '3px solid #fb1c7f',
            }}
            onClick={() => {
              setExtractionMethod('A');
            }}
          >
            Version 1
          </button>
          <button
            className="transparent-button mobile clickable"
            style={{
              border: extractionMethod === 'B' && '3px solid #fb1c7f',
            }}
            onClick={() => {
              setExtractionMethod('B');
            }}
          >
            Version 2
          </button>
        </div>
      ) : (
        <div></div>
      )}
      <form
        style={{ display: 'flex', flexDirection: 'column', width: '100%' }}
        onSubmit={ async (e) => {
          e.preventDefault();

          if (text.length > ARTICLE_MAX_LENGTH_HD) {
            alert(`Text is too long. Please keep it under ${ARTICLE_MAX_LENGTH_HD} characters.`);
            return;
          }
          
          // Check if text is too short
          const textToCheck = extractionMethod === 'A' ? text : backupText;
          if (textToCheck.length < 20) {
            const confirmed = window.confirm("Text under 20 characters tends to convert poorly. Do you want to continue anyway?");
            if (!confirmed) {
              return;
            }
          }
          
          setButtonMessage('Uploading...')
          setIsLoading(true);
          let txtFileUrl = ''
          try {
            const res = await uploadTextToPresignedUrl(preSignedUrl, text, setButtonMessage)
            txtFileUrl = res.config.url.split('?')[0]
          } catch (err) {
            console.log(err)
            setButtonMessage('Failed to Upload')
            setIsLoading(false)
            return 
          }
          

          setButtonMessage('Sending...')
          
          // Set a timeout to auto-progress after 15 seconds
          const timeout = setTimeout(() => {
            setIsLoading(false);
            setButtonMessage('Processing in background...');
            window.location.href = '/playlist';
          }, 1000);

          addArticleToUserPlaylist(
            {
              title: title,
              type: type,
              article_url: txtFileUrl,
              article_id: txtFileUrl.replace("https://", ""),
              text: ""
            }, 
            userStore.idToken,
            '/add/text'
          ).then(() => {
            clearTimeout(timeout);
            setIsLoading(false);
            setButtonMessage('Sent!');
            window.location.href = '/playlist';
          }).catch((err) => {
            clearTimeout(timeout);
            setIsLoading(false);
            setButtonMessage('Failed to Send');
          });
        }}
      >
        <input
          type="text"
          placeholder="Title"
          value={title}
          className="input-text"
          onChange={(e) => setTitle(e.target.value)}
          style={{ marginBottom: '10px' }}
        ></input>

        <textarea
          id="input-text-area"
          name="text"
          className="input-text"
          value={extractionMethod === 'A' ? text : backupText}
          autoFocus={true}
          onChange={(e) => {
            if (extractionMethod === 'A') {
              setText(e.target.value);
            } else {
              setBackupText(e.target.value);
            }
          }}
          style={{ height: '39vh' }}
        ></textarea>
        <div
          style={{
            color:
              extractionMethod === 'A'
                ? text.length > maxLength && 'red'
                : backupText.length > maxLength && 'red',
          }}
        >
          {extractionMethod === 'A' ? text.length : backupText.length} /{' '}
          {maxLength} characters
        </div>
        <div>
          <div className="confirm">
            <button type="submit" className="send-text-cta" style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}>
              {isLoading && (<img
                  src={loadingIcon}
                  style={{ height: '25px', marginRight: '5px' }}
                  alt="loading..."
                />)} <span>{buttonMessage}</span>
            </button>
            <Link
              to="/add"
              onClick={(e) => {
                store.updateAddUrl('');
              }}
            >
              Cancel
            </Link>
          </div>
        </div>
      </form>
    </div>
  );
});

export default EditText;
